import { FC } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";

const RefreshButton: FC<({
    onClick: () => void;
    isRefresh?: boolean;
})>
    = ({
        onClick,
        isRefresh = false,
    }) => (
        <div
            className="flex items-center cursor-pointer color-primary border-primary px-3 py-1 rounded-full"
            onClick={onClick}
            style={{ background: "#EBFFF0" }}
        >
            <RefreshIcon
                className={`${isRefresh ? "animate-spin" : ""} mr-1`} />
            <span className="fs-14 color-primary font-semibold">
                Refresh
            </span>
        </div>
    )

export default RefreshButton;